export const FETCH_SHIPPERLIST_INIT = "FETCH_SHIPPERLIST_INIT";
export const FETCH_SHIPPERLIST_SUCCESS = FETCH_SHIPPERLIST_INIT + "_SUCCESS";
export const FETCH_SHIPPERLIST_FAIL = FETCH_SHIPPERLIST_INIT + "_FAIL";